import Div from "@components/elements/div"
import styled from "styled-components"
import media from "../../../styles/media"
import theme from "../../../styles/theme"

export const CtaContainer = styled(Div)`
  width: 100%;
  display: block;
  position: relative;
  border-radius: 1rem;
  box-shadow: rgb(0 0 0 / 5%) 0px 4px 24px;
  text-align: center;
  background: #111427;
  
  ${media.md`
    ${({ show }) => !show && `display: none;`}
  `}

  h3 {
    font-size: 2rem;
    line-height: 1.25;
    margin: 1rem 0;
    letter-spacing: -0.03rem;
  }

  ::before {
    content: "";
    background: linear-gradient(90deg, ${theme.color.blue500} 0%, ${theme.color.blue400} 100%);
    border-radius: 1rem;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    mask-image: linear-gradient(rgb(0, 0, 0), rgba(0, 0, 0, 0));
  }
`
